export function DownloadModalInstructions() {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <div className="bg-purple-brand-500 flex size-6 shrink-0 items-center justify-center rounded">
          <span className="text-sm leading-none font-bold text-white">1</span>
        </div>
        <p className="text-muted-foreground text-sm leading-5">
          <span className="text-cold-100 font-bold">Download the app</span>
          {' – bring Duos to your phone.'}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <div className="bg-purple-brand-500 flex size-6 shrink-0 items-center justify-center rounded">
          <span className="text-sm leading-none font-bold text-white">2</span>
        </div>
        <p className="text-muted-foreground text-sm leading-5">
          <span className="text-cold-100 font-bold">Enable notifications</span>
          {' – so you never miss a message or match.'}
        </p>
      </div>
    </div>
  );
}
